$(function () {
;(function() {
  const FALLBACK_GLOBAL_HEADER = {
    "data": {
        "globalNavigationHeaderList": {
            "items": [
                {
                    "market": "en-us",
                    "logoImage": {
                        "mimeType": "image/png",
                        "_path": "/content/dam/princess/cfm-assets-demo/Princess logo redesign.png"
                    },
                    "logoImageForMobile": {
                        "mimeType": "image/png",
                        "_path": "/content/dam/princess/cfm-assets-demo/Princess logo redesign.png"
                    },
                    "logoPathUrl": null,
                    "anchorLabelForMobileMenuToggle": "Skip to Menu Toggle Button ",
                    "navigationToggleLabel": "Toggle Navigation Menu",
                    "mainMenuLinks": [
                        {
                            "menuTextLink": "Destinations",
                            "iconImagePath": {
                                "mimeType": "image/png",
                                "_path": "/content/dam/princess/cfm-assets-demo/Icon Logo.png"
                            },
                            "isFeatured": false,
                            "isCtaDisabled": true,
                            "isExternal": false,
                            "internalPath": null,
                            "externalUrl": null,
                            "openInNewTab": false,
                            "linkType": "default",
                            "princesscomAppLinks": null,
                            "flagMessage": null,
                            "haspromotion": true,
                            "promotionpath": {
                                "title": "Sail with the highest-rated Alaska cruise line",
                                "image": {
                                    "mimeType": "image/png",
                                    "_path": "/content/dam/princess/cfm-assets-demo/promo1.png"
                                },
                                "ctaText": "Learn More",
                                "princesscomAppLinks": "www",
                                "isExternal": false,
                                "externalPath": "/content/princess/en-us/cruise-destinations/alaska-cruises",
                                "internalPath": null,
                                "description": {
                                    "html": "<p><span data-teams=\"true\"><span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\">Check the Alaska must-sees off your list.</span></span></p>\n"
                                }
                            },
                            "sublink": [
                                {
                                    "menuTextLink": "Cruise Destinations",
                                    "iconImagePath": null,
                                    "isFeatured": false,
                                    "isCtaDisabled": true,
                                    "isExternal": false,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": null,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": true,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Alaska",
                                            "iconImagePath": null,
                                            "isFeatured": true,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Caribbean",
                                            "iconImagePath": null,
                                            "isFeatured": true,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations/caribbean-cruises"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Europe",
                                            "iconImagePath": null,
                                            "isFeatured": true,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations/europe-cruises"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Asia",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations/asia-cruises"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Australia & South Pacific",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": true,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": [
                                                {
                                                    "menuTextLink": "Australia",
                                                    "iconImagePath": null,
                                                    "isFeatured": false,
                                                    "isCtaDisabled": false,
                                                    "isExternal": false,
                                                    "internalPath": {
                                                        "_path": "/content/princess/en-us/cruise-destinations/australia-cruises"
                                                    },
                                                    "externalUrl": null,
                                                    "openInNewTab": false,
                                                    "linkType": "default",
                                                    "princesscomAppLinks": "www",
                                                    "flagMessage": null,
                                                    "haspromotion": false,
                                                    "promotionpath": null
                                                },
                                                {
                                                    "menuTextLink": "New Zealand",
                                                    "iconImagePath": null,
                                                    "isFeatured": false,
                                                    "isCtaDisabled": false,
                                                    "isExternal": false,
                                                    "internalPath": {
                                                        "_path": "/content/princess/en-us/cruise-destinations/australia-cruises/new-zealand"
                                                    },
                                                    "externalUrl": null,
                                                    "openInNewTab": false,
                                                    "linkType": "default",
                                                    "princesscomAppLinks": "www",
                                                    "flagMessage": null,
                                                    "haspromotion": false,
                                                    "promotionpath": null
                                                },
                                                {
                                                    "menuTextLink": "Tahiti and South Pacific",
                                                    "iconImagePath": null,
                                                    "isFeatured": false,
                                                    "isCtaDisabled": false,
                                                    "isExternal": false,
                                                    "internalPath": {
                                                        "_path": "/content/princess/en-us/cruise-destinations/tahiti-south-pacific-cruises"
                                                    },
                                                    "externalUrl": null,
                                                    "openInNewTab": false,
                                                    "linkType": "default",
                                                    "princesscomAppLinks": "www",
                                                    "flagMessage": null,
                                                    "haspromotion": false,
                                                    "promotionpath": null
                                                },
                                                {
                                                    "menuTextLink": "Hawaii",
                                                    "iconImagePath": null,
                                                    "isFeatured": false,
                                                    "isCtaDisabled": false,
                                                    "isExternal": false,
                                                    "internalPath": {
                                                        "_path": "/content/princess/en-us/cruise-destinations/hawaii-cruises"
                                                    },
                                                    "externalUrl": null,
                                                    "openInNewTab": false,
                                                    "linkType": "default",
                                                    "princesscomAppLinks": "www",
                                                    "flagMessage": null,
                                                    "haspromotion": false,
                                                    "promotionpath": null
                                                }
                                            ]
                                        },
                                        {
                                            "menuTextLink": "Caribbean",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations/caribbean-cruises"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Europe",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Epic Voyages",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Japan",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "North America",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": true,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": [
                                                {
                                                    "menuTextLink": "Alaska",
                                                    "iconImagePath": null,
                                                    "isFeatured": false,
                                                    "isCtaDisabled": false,
                                                    "isExternal": false,
                                                    "internalPath": {
                                                        "_path": "/content/princess/en-us/cruise-destinations/alaska-cruises"
                                                    },
                                                    "externalUrl": null,
                                                    "openInNewTab": false,
                                                    "linkType": "default",
                                                    "princesscomAppLinks": "www",
                                                    "flagMessage": null,
                                                    "haspromotion": false,
                                                    "promotionpath": null
                                                },
                                                {
                                                    "menuTextLink": "California Pacific Coast",
                                                    "iconImagePath": null,
                                                    "isFeatured": false,
                                                    "isCtaDisabled": false,
                                                    "isExternal": false,
                                                    "internalPath": {
                                                        "_path": "/content/princess/en-us/cruise-destinations/california-coast-cruises"
                                                    },
                                                    "externalUrl": null,
                                                    "openInNewTab": false,
                                                    "linkType": "default",
                                                    "princesscomAppLinks": "www",
                                                    "flagMessage": null,
                                                    "haspromotion": false,
                                                    "promotionpath": null
                                                },
                                                {
                                                    "menuTextLink": "Canada & New England",
                                                    "iconImagePath": null,
                                                    "isFeatured": false,
                                                    "isCtaDisabled": false,
                                                    "isExternal": false,
                                                    "internalPath": {
                                                        "_path": "/content/princess/en-us/cruise-destinations/canada-cruises"
                                                    },
                                                    "externalUrl": null,
                                                    "openInNewTab": false,
                                                    "linkType": "default",
                                                    "princesscomAppLinks": "www",
                                                    "flagMessage": null,
                                                    "haspromotion": false,
                                                    "promotionpath": null
                                                },
                                                {
                                                    "menuTextLink": "Mexico",
                                                    "iconImagePath": null,
                                                    "isFeatured": false,
                                                    "isCtaDisabled": false,
                                                    "isExternal": false,
                                                    "internalPath": {
                                                        "_path": "/content/princess/en-us/cruise-destinations/mexico-cruises"
                                                    },
                                                    "externalUrl": null,
                                                    "openInNewTab": false,
                                                    "linkType": "default",
                                                    "princesscomAppLinks": "www",
                                                    "flagMessage": null,
                                                    "haspromotion": false,
                                                    "promotionpath": null
                                                }
                                            ]
                                        },
                                        {
                                            "menuTextLink": "Panama Canal",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations/panama-canal-cruises"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "South America & Antarctica",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "World Cruise",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations/world-cruises"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Cruise Ports",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations/departure-ports"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "View All",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-destinations"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                },
                                {
                                    "menuTextLink": "Cruise Types",
                                    "iconImagePath": null,
                                    "isFeatured": null,
                                    "isCtaDisabled": true,
                                    "isExternal": null,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": null,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": null,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Cruisetours",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Epic Voyages",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Theme Cruises",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "World Cruise",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                },
                                {
                                    "menuTextLink": "Shore Excursions",
                                    "iconImagePath": null,
                                    "isFeatured": false,
                                    "isCtaDisabled": true,
                                    "isExternal": false,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": false,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": false,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Alaska Shore Excursions",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": "/en-us/cruise-destinations/alaska-cruises/shore-excursions",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Local Connections",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": "/en-us/cruise-destinations/local-connections",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Find Shore Excursions",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": "/ports-excursions/",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "menuTextLink": "Explore Ships",
                            "iconImagePath": null,
                            "isFeatured": false,
                            "isCtaDisabled": true,
                            "isExternal": false,
                            "internalPath": null,
                            "externalUrl": null,
                            "openInNewTab": false,
                            "linkType": "default",
                            "princesscomAppLinks": null,
                            "flagMessage": null,
                            "haspromotion": true,
                            "promotionpath": {
                                "title": "Talk About Exciting & New",
                                "image": {
                                    "mimeType": "image/jpeg",
                                    "_path": "/content/dam/princess/homepage/grid-snippet/star-princess-exterior-render.jpg"
                                },
                                "ctaText": "Learn More",
                                "princesscomAppLinks": "www",
                                "isExternal": true,
                                "externalPath": "/content/princess/en-us/ships-and-experience/ships/st-star-princess",
                                "internalPath": null,
                                "description": {
                                    "html": "<p><span data-teams=\"true\"><span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\">Star Princess® was designed to bring you to the world, and the world to you.</span></span></p>\n"
                                }
                            },
                            "sublink": [
                                {
                                    "menuTextLink": "Ships",
                                    "iconImagePath": null,
                                    "isFeatured": false,
                                    "isCtaDisabled": true,
                                    "isExternal": false,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": null,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": false,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Caribbean Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/cb-caribbean-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Coral Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/co-coral-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Crown Princess ",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/kp-crown-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Diamond Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/di-diamond-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Discovery Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/xp-discovery-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Emerald Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": "/ships-and-experience/ships/ep-emerald-princess",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Enchanced Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/ex-enchanted-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Grand Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/ap-grand-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Island Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/ip-island-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Majestic Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/mj-majestic-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Regal Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/gp-regal-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Royal Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/rp-royal-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Ruby Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/ru-ruby-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Sapphire Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/sa-sapphire-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Sky Princess",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/yp-sky-princess"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Star Princess - New",
                                            "iconImagePath": null,
                                            "isFeatured": true,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": "/content/princess/en-us/ships-and-experience/ships/st-star-princess",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Sun Princess - New",
                                            "iconImagePath": null,
                                            "isFeatured": true,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": "/content/princess/en-us/ships-and-experience/ships/su-sun-princess",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "View All",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                },
                                {
                                    "menuTextLink": "Staterooms",
                                    "iconImagePath": null,
                                    "isFeatured": false,
                                    "isCtaDisabled": true,
                                    "isExternal": false,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": false,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": false,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Reserve Collection",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/staterooms/reserve-collection"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Sanctuary Collection",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/sanctuary-collection"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Suites & More",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/ships/staterooms/suites"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                },
                                {
                                    "menuTextLink": "Onboard Experience",
                                    "iconImagePath": null,
                                    "isFeatured": false,
                                    "isCtaDisabled": true,
                                    "isExternal": false,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": false,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": false,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Activities",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/activities"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Casino",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/activities/casino"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Dining",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/food-and-dining/dining-reservations"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Entertainment",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/entertainment"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Kids, Teens & Families",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/kids-and-teens"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Onboard Packages",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/food-and-dining/beverages"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Wellness",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/wellness"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "menuTextLink": "Deals",
                            "iconImagePath": null,
                            "isFeatured": false,
                            "isCtaDisabled": true,
                            "isExternal": false,
                            "internalPath": null,
                            "externalUrl": null,
                            "openInNewTab": false,
                            "linkType": "default",
                            "princesscomAppLinks": null,
                            "flagMessage": null,
                            "haspromotion": true,
                            "promotionpath": {
                                "title": "Up to $200 instant Savings+ Up to 40% Off + Free Room Upgrade + Free 3rd and 4th Guests ",
                                "image": null,
                                "ctaText": "Learn More",
                                "princesscomAppLinks": "www",
                                "isExternal": false,
                                "externalPath": "/en-us/cruise-deals-promotions/flash-sale",
                                "internalPath": null,
                                "description": {
                                    "html": "<p>Discover our current featured deals, plus many more ways to save.</p>"
                                }
                            },
                            "sublink": [
                                {
                                    "menuTextLink": "Cruise Deals",
                                    "iconImagePath": null,
                                    "isFeatured": false,
                                    "isCtaDisabled": true,
                                    "isExternal": false,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": false,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": false,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Up to 40% Off + Free Room Upgrade",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": "https://www.princess.com/en-us/cruise-deals-promotions/wa",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Sanctuary Collection Savings",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-deals-promotions/sanctuary-collection-sale"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Last Minute Cruise Deals",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-deals-promotions/last-minute-cruise-deals"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Save up to $400 on Princess Picks",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-deals-promotions/princess-picks"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Cruise Package Deals",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Military Cruise Benefits",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-deals-promotions/military-benefit-program"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Casino Perks & Discounts",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/activities/casino"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "View All",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/cruise-deals-promotions"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                },
                                {
                                    "menuTextLink": "Packages",
                                    "iconImagePath": null,
                                    "isFeatured": false,
                                    "isCtaDisabled": true,
                                    "isExternal": false,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": false,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": false,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Plus & Premier Packages",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Beverage Packages",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": {
                                                "_path": "/content/princess/en-us/ships-and-experience/onboard-experience/food-and-dining/beverages"
                                            },
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Cruise & Flight Packages",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Celebration Packages",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Internet Packages",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Romance Package",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                },
                                {
                                    "menuTextLink": "Loyalty",
                                    "iconImagePath": null,
                                    "isFeatured": false,
                                    "isCtaDisabled": true,
                                    "isExternal": false,
                                    "internalPath": null,
                                    "externalUrl": null,
                                    "openInNewTab": false,
                                    "linkType": "default",
                                    "princesscomAppLinks": null,
                                    "flagMessage": null,
                                    "haspromotion": false,
                                    "promotionpath": null,
                                    "sublink": [
                                        {
                                            "menuTextLink": "Casino",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Captain's Circle",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": true,
                                            "internalPath": null,
                                            "externalUrl": "https://book.princess.com/captaincircle/membershipBenefits.page",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "book",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Create an Account",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": true,
                                            "internalPath": null,
                                            "externalUrl": "https://www.princess.com/my-princess/register/",
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Military",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": null,
                                            "openInNewTab": false,
                                            "linkType": "default",
                                            "princesscomAppLinks": "www",
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        },
                                        {
                                            "menuTextLink": "Princess® Rewards Visa® Card",
                                            "iconImagePath": null,
                                            "isFeatured": false,
                                            "isCtaDisabled": false,
                                            "isExternal": false,
                                            "internalPath": null,
                                            "externalUrl": "https://www.princessvisa.com/",
                                            "openInNewTab": true,
                                            "linkType": "default",
                                            "princesscomAppLinks": null,
                                            "flagMessage": null,
                                            "haspromotion": false,
                                            "promotionpath": null,
                                            "sublink": []
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "findACruiseCta": {
                        "menuTextLink": "Find a Cruise",
                        "iconImagePath": {
                            "mimeType": "image/png",
                            "_path": "/content/dam/princess/cfm-assets-demo/Icon Logo.png"
                        },
                        "isFeatured": false,
                        "isCtaDisabled": false,
                        "isExternal": true,
                        "internalPath": null,
                        "externalUrl": "https://stagewww.princess.com/cruise-search/results/",
                        "openInNewTab": false,
                        "linkType": "default",
                        "princesscomAppLinks": "www",
                        "flagMessage": null,
                        "haspromotion": false,
                        "promotionpath": null
                    },
                    "subscribeLink": {
                        "menuTextLink": "Subscribe",
                        "iconImagePath": {
                            "mimeType": "image/png",
                            "_path": "/content/dam/princess/cfm-assets-demo/suscribe_icon.png"
                        },
                        "isFeatured": false,
                        "isCtaDisabled": false,
                        "isExternal": false,
                        "internalPath": null,
                        "externalUrl": null,
                        "openInNewTab": false,
                        "linkType": "modal",
                        "princesscomAppLinks": null,
                        "flagMessage": null,
                        "haspromotion": false,
                        "promotionpath": null
                    },
                    "callMeLink": {
                        "menuTextLink": "1-800-774-6237",
                        "iconImagePath": null,
                        "isFeatured": false,
                        "isCtaDisabled": false,
                        "isExternal": true,
                        "internalPath": null,
                        "externalUrl": "tel:1-800-774-6237",
                        "openInNewTab": false,
                        "linkType": "default",
                        "princesscomAppLinks": null
                    },
                    "searchLink": {
                        "menuTextLink": "Search",
                        "iconImagePath": {
                            "mimeType": "image/png",
                            "_path": "/content/dam/princess/cfm-assets-demo/Princess logo redesign.png"
                        },
                        "isFeatured": false,
                        "isCtaDisabled": false,
                        "isExternal": false,
                        "internalPath": null,
                        "externalUrl": null,
                        "openInNewTab": false,
                        "linkType": "default",
                        "princesscomAppLinks": null
                    },
                    "favorites": null,
                    "login": {
                        "menuTextLink": "Log in",
                        "iconImagePath": {
                            "mimeType": "image/png",
                            "_path": "/content/dam/princess/cfm-assets-demo/userIcon.png"
                        },
                        "isFeatured": false,
                        "isCtaDisabled": false,
                        "isExternal": true,
                        "internalPath": null,
                        "externalUrl": "https://stagewww.princess.com/my-princess/login/",
                        "openInNewTab": false,
                        "linkType": "default",
                        "princesscomAppLinks": "www"
                    },
                    "myAccount": {
                        "menuTextLink": "My Account",
                        "iconImagePath": null,
                        "isFeatured": false,
                        "isCtaDisabled": false,
                        "isExternal": true,
                        "internalPath": null,
                        "externalUrl": "https://stagebook.princess.com/captaincircle/myPrincess.page",
                        "openInNewTab": false,
                        "linkType": "default",
                        "princesscomAppLinks": null
                    },
                    "saved": {
                        "menuTextLink": "Saved",
                        "iconImagePath": null,
                        "isFeatured": false,
                        "isCtaDisabled": false,
                        "isExternal": false,
                        "internalPath": null,
                        "externalUrl": null,
                        "openInNewTab": false,
                        "linkType": "default",
                        "princesscomAppLinks": "www"
                    },
                    "logoutModalMessage": {
                        "html": "<p><b>You have been logged out</b></p>\n<p>Your window will update in 5 secs</p>\n"
                    },
                    "register": {
                        "menuTextLink": "Create account",
                        "iconImagePath": {},
                        "isFeatured": false,
                        "isCtaDisabled": false,
                        "isExternal": true,
                        "internalPath": null,
                        "externalUrl": "https://stagewww.princess.com/my-princess/register/",
                        "openInNewTab": false,
                        "linkType": "default",
                        "princesscomAppLinks": "www"
                    },
                    "manageBookingIcon": null,
                    "manageBookingLinkText": "Manage booking",
                    "manageBookingNavigation": {
                        "cartLabelText": "Cart",
                        "checkinLabelText": "Check In",
                        "bookingLabelText": "BOOKING",
                        "shipLabelText": "SHIP",
                        "dateLabelText": "DATES",
                        "makeAPaymentLabelText": "Make a Payment",
                        "makeAPaymenturl": "/content/makeapyamnet",
                        "mainBookingMenuLinks": [
                            {
                                "menuTextLink": "Booking Details",
                                "iconImagePath": {},
                                "isFeatured": false,
                                "isCtaDisabled": true,
                                "isExternal": false,
                                "internalPath": null,
                                "externalUrl": null,
                                "openInNewTab": false,
                                "linkType": "default",
                                "princesscomAppLinks": "book",
                                "flagMessage": null,
                                "haspromotion": true,
                                "promotionpath": {
                                    "title": "Bid for a Stateroom Upgrade",
                                    "image": {
                                        "mimeType": "image/png",
                                        "_path": "/content/dam/test/nav-deals-desktop.png"
                                    },
                                    "ctaText": "Learn more",
                                    "isExternal": true,
                                    "princesscomAppLinks": "www",
                                    "externalPath": "https://www.princess.com/content/princess/en-us/plan/princess-cruise-room-upgrade",
                                    "internalPath": null,
                                    "description": {
                                        "html": "<p>Make your cruise experience even better with just a bid</p>\n"
                                    }
                                },
                                "sublink": [
                                    {
                                        "menuTextLink": "Booking Summary",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/manage-booking/summary.page",
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": "book",
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    },
                                    {
                                        "menuTextLink": "Cruise Invoice",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/manage-booking/paymentsAndCredits.page",
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": null,
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    },
                                    {
                                        "menuTextLink": "Travel Itinerary",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/manage-booking/itinerary.page",
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": null,
                                        "flagMessage": "itinerary",
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    },
                                    {
                                        "menuTextLink": "To-Do-List",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": true,
                                        "isExternal": false,
                                        "internalPath": null,
                                        "externalUrl": null,
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": null,
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": [
                                            {
                                                "menuTextLink": "Prepay Tips",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/paymentsAndCredits.page?accordion=gratuities",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": null,
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            },
                                            {
                                                "menuTextLink": "Print Luggage Tags",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/documents.page",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": null,
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            },
                                            {
                                                "menuTextLink": "Check In",
                                                "iconImagePath": {},
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/paxCheckIn.page",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": "book",
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            },
                                            {
                                                "menuTextLink": "Bed Configuration",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/paxCheckIn.page?accordion=bed-config",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": null,
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            },
                                            {
                                                "menuTextLink": "Provide Flight Info",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/flightTransfer.page?accordion=independent-flight",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": null,
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            },
                                            {
                                                "menuTextLink": "Onboard Language Preference",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/paxCheckIn.page?accordion=onboard-lang",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": null,
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            },
                                            {
                                                "menuTextLink": "Vacation Protection",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/insurance.page",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": null,
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            }
                                        ]
                                    },
                                    {
                                        "menuTextLink": "Bid for Stateroom Upgrade",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/plan/princess-cruise-room-upgrade",
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": "www",
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    },
                                    {
                                        "menuTextLink": "Onboard Purchases",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": true,
                                        "isExternal": false,
                                        "internalPath": null,
                                        "externalUrl": null,
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": null,
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": [
                                            {
                                                "menuTextLink": "Spa Reservations",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/onboard/spa.page",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": "book",
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            },
                                            {
                                                "menuTextLink": "Onboard Reservations & Purchases",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/manage-booking/onboard/home.page",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": "book",
                                                "flagMessage": null,
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            },
                                            {
                                                "menuTextLink": "Excursions",
                                                "iconImagePath": null,
                                                "isFeatured": false,
                                                "isCtaDisabled": false,
                                                "isExternal": true,
                                                "internalPath": null,
                                                "externalUrl": "/cruise-excursions/cp-landing",
                                                "openInNewTab": false,
                                                "linkType": "default",
                                                "princesscomAppLinks": "www",
                                                "flagMessage": "Online purchase is closed, but excursions are still available onboard",
                                                "haspromotion": false,
                                                "promotionpath": null,
                                                "sublink": []
                                            }
                                        ]
                                    },
                                    {
                                        "menuTextLink": "SFCC Excursions - Stage",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/booking/addon/category/excursions",
                                        "openInNewTab": true,
                                        "linkType": "default",
                                        "princesscomAppLinks": "www",
                                        "flagMessage": "Online purchase is closed, but excursions are still available onboard",
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    },
                                    {
                                        "menuTextLink": "SFCC Excursions - UAT",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/booking/addon/category/excursions?sfccEnv=uat",
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": "www",
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    }
                                ]
                            },
                            {
                                "menuTextLink": "Cruise Packages",
                                "iconImagePath": {},
                                "isFeatured": false,
                                "isCtaDisabled": false,
                                "isExternal": true,
                                "internalPath": null,
                                "externalUrl": "/manage-booking/onboard/cruisePackages.page",
                                "openInNewTab": false,
                                "linkType": "default",
                                "princesscomAppLinks": "book",
                                "flagMessage": null,
                                "haspromotion": true,
                                "promotionpath": {
                                    "title": "Lorem Ipsum Dolor",
                                    "image": {
                                        "mimeType": "image/png",
                                        "_path": "/content/dam/princess/cfm-assets-demo/Promotion Image Generic.png"
                                    },
                                    "ctaText": "Learn More",
                                    "isExternal": false,
                                    "princesscomAppLinks": null,
                                    "externalPath": null,
                                    "internalPath": {
                                        "_path": "/content/princess/en-us"
                                    },
                                    "description": {
                                        "html": "<p>Lorem Ipsum dolor sit amet, consectetur adipiscing elit. Curabitur non consequat erat.&nbsp;</p>\n"
                                    }
                                },
                                "sublink": []
                            },
                            {
                                "menuTextLink": "Excursions",
                                "iconImagePath": {},
                                "isFeatured": false,
                                "isCtaDisabled": false,
                                "isExternal": true,
                                "internalPath": null,
                                "externalUrl": "/cruise-excursions/cp-landing",
                                "openInNewTab": false,
                                "linkType": "default",
                                "princesscomAppLinks": "www",
                                "flagMessage": "Online purchase is closed, but excursions are still available onboard",
                                "haspromotion": false,
                                "promotionpath": null,
                                "sublink": []
                            },
                            {
                                "menuTextLink": "Flight & Transfers",
                                "iconImagePath": {},
                                "isFeatured": false,
                                "isCtaDisabled": false,
                                "isExternal": true,
                                "internalPath": null,
                                "externalUrl": "/manage-booking/flightTransfer.page",
                                "openInNewTab": false,
                                "linkType": "default",
                                "princesscomAppLinks": "book",
                                "flagMessage": null,
                                "haspromotion": false,
                                "promotionpath": null,
                                "sublink": []
                            },
                            {
                                "menuTextLink": "Food & Drink",
                                "iconImagePath": {
                                    "mimeType": "image/png",
                                    "_path": "/content/dam/princess/corporate/icons/ez-air-late-arrivals-icon.png"
                                },
                                "isFeatured": false,
                                "isCtaDisabled": true,
                                "isExternal": true,
                                "internalPath": null,
                                "externalUrl": null,
                                "openInNewTab": false,
                                "linkType": "default",
                                "princesscomAppLinks": null,
                                "flagMessage": null,
                                "haspromotion": true,
                                "promotionpath": {
                                    "title": "Save Big On Things You Care About The Most",
                                    "image": {
                                        "mimeType": "image/png",
                                        "_path": "/content/dam/test/nav-fewd-and-drink-desktop.png"
                                    },
                                    "ctaText": "Learn More",
                                    "isExternal": true,
                                    "princesscomAppLinks": "www",
                                    "externalPath": "https://stagewww.princess.com/content/princess/en-us/cruise-deals-promotions/plus-premier-cruise-packages",
                                    "internalPath": null,
                                    "description": {
                                        "html": "<p>Enjoy unlimited dining at our specialty restaurants included in your fare when you book Princess Premier!</p>"
                                    }
                                },
                                "sublink": [
                                    {
                                        "menuTextLink": "Beverages Packages",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/manage-booking/onboard/home.page?service=beverages&interstitial=true",
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": "book",
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    },
                                    {
                                        "menuTextLink": "Dining Experiences & Packages",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/manage-booking/onboard/viewservicelisting.page?service=culinary&items=0635,0636,3013,3012,6071,3014,3015,3016,3020,3017,3018,3019",
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": "book",
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    },
                                    {
                                        "menuTextLink": "Wine & Spirits Delivery",
                                        "iconImagePath": null,
                                        "isFeatured": false,
                                        "isCtaDisabled": false,
                                        "isExternal": true,
                                        "internalPath": null,
                                        "externalUrl": "/manage-booking/onboard/viewservicelisting.page?service=cellars&items=0478,0439,0479,0741,0740,0742,0476,0443,0744,0745,0746,0747,2047,0448,0749,0750,0751,0752,0753,0454,0755,0756,0757,0758,0475,0472,2046,0465,0769,0466,0764,0459,",
                                        "openInNewTab": false,
                                        "linkType": "default",
                                        "princesscomAppLinks": "book",
                                        "flagMessage": null,
                                        "haspromotion": false,
                                        "promotionpath": null,
                                        "sublink": []
                                    }
                                ]
                            },
                            {
                                "menuTextLink": "Spa",
                                "iconImagePath": null,
                                "isFeatured": false,
                                "isCtaDisabled": false,
                                "isExternal": true,
                                "internalPath": null,
                                "externalUrl": "/manage-booking/onboard/spa.page",
                                "openInNewTab": false,
                                "linkType": "default",
                                "princesscomAppLinks": "book",
                                "flagMessage": null,
                                "haspromotion": false,
                                "promotionpath": null,
                                "sublink": []
                            },
                            {
                                "menuTextLink": "Onboard Extras",
                                "iconImagePath": null,
                                "isFeatured": true,
                                "isCtaDisabled": false,
                                "isExternal": true,
                                "internalPath": null,
                                "externalUrl": "/manage-booking/onboard/home.page",
                                "openInNewTab": false,
                                "linkType": "default",
                                "princesscomAppLinks": "book",
                                "flagMessage": null,
                                "haspromotion": false,
                                "promotionpath": null,
                                "sublink": []
                            }
                        ]
                    },
                    "skipNavigationLinkText": "Skip to main content",
                    "openSearchAccessibilityLabel": "Search",
                    "utilityNavigationAccessibilityLabel": "Header"
                }
            ]
        }
    }
}

  
  const NAV_MENU = 'nav-menu';
  const MOBILE_NAV_MENU = 'mobile-nav-menu';
  const PCL_CAPTAIN_CIRCLE_NAV = 'pcl-captain-circle-nav';
  const IS_MOBILE_MENU_OPENED = 'is-mobile-menu-opened';
  const CAPTAIN_CIRCLE_HEADER_CONTAINER = 'pcl-captain-circle-header-container';
  const PCL_CAPTAIN_CIRCLE_HEADER= 'pcl-captain-circle-header'

  const CLASSES = Object.fromEntries(Object.entries({
    mb: "mb",
    cc: "cc",
    open: "open",
    fixed: "fixed",
    mobile: "mobile",
    desktop: "desktop",
    header: "header",
    logo: "logo",
    burgerBtn: "burgerBtn",
    burgerBtnText: "burgerBtnText",
    searchBtnWrapper: "searchBtnWrapper",
    searchBtn: "searchBtn",
    expandBtn: "expandBtn",
    expandBtnText: "expandBtnText",
    chevron: "chevron",
    closeBtn: "closeBtn",
    closeBtnText: "closeBtnText",
    firstLevelColumn:"firstLevelColumn",
    link: "link",
    linkText: "linkText",
    layer: "layer",
    nav: "nav",
    scrollContainer: "scrollContainer",
    menuWrapper: "menuWrapper",
    menu: "menu",
    menuItem: "menuItem",
    menuControlPanel: "menuControlPanel",
    menuControlPanelBackBtn: "menuControlPanelBackBtn",
    menuControlPanelBackBtnText: "menuControlPanelBackBtnText",
    menuControlPanelTitle: "menuControlPanelTitle",
    menuControlPanelCloseBtn: "menuControlPanelCloseBtn",
    menuControlPanelCloseBtnText: "menuControlPanelCloseBtn",
    submenu: "submenu",
    submenuItem: "submenuItem",
    promo: "promo",
    promoImg: "promoImg",
    promoTitle: "promoTitle",
    promoDescription: "promoDescription",
    promoLink: "promoLink",
  }).map(([key, value]) => ([
    key, 'nav-menu__' + value
  ])));

  const ATTRIBUTES = {
    ariaExpanded: 'aria-expanded',
    ariaLabel: 'aria-label',
    dataTrack: 'data-track',
    dataTrackId: 'data-track-id',
    dataComponentLevel: 'data-track-component-level-1',
  };

  const BREAKPOINTS = {
    xs: 1025
  }

  let PAGE_WIDTH = getPageWidth();

  window.addEventListener("resize", () => {
    PAGE_WIDTH = getPageWidth();
  });

  async function fetchGlobalHeader() {
    try {
      const response = await fetch(`${$wwwURL}/graphql/execute.json/princess/globalheader`);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching global header data:', error);
    }
  }
  function getScale () {
    if (window.outerWidth && window.innerWidth) {
      return window.outerWidth / window.innerWidth;
    }
    return window.devicePixelRatio || 1;
  };

  function fixElementOnScroll($element) {
    if (!$element) return;
    const elementPosition = $element.offsetTop || 0;
    const handleScroll = () => {
        if (window.innerWidth <= 1024) {
            if (window.scrollY > elementPosition) {
              const CAP_AT = 2; // 200%
              const scale = getScale();            
              if (scale < CAP_AT) {
                $element.classList.add(CLASSES.fixed);
              }
            } else {
                $element.classList.remove(CLASSES.fixed);
            }
        } else {
            $element.classList.remove(CLASSES.fixed);
        }
    };
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
  }

  function getRootElement(pageWidth) {
    if(pageWidth === undefined) return document;

    return pageWidth >= BREAKPOINTS.xs ? document.querySelector(NAV_MENU) : document.querySelector(MOBILE_NAV_MENU)
  }

  function getPageWidth () {
    if (self.innerWidth) {
      return self.innerWidth;
    }

    if (document.documentElement && document.documentElement.clientHeight) {
      return document.documentElement.clientWidth;
    }

    if (document.body) {
      return document.body.clientWidth;
    }

    return 0;
  }

  function getMainMenuLinks (response) {
    if (!response || typeof response !== 'object') {
      return [];
    }

    return response?.data?.globalNavigationHeaderList?.items?.find(item => item.mainMenuLinks)?.mainMenuLinks;
  }

  function getFindACruiseCta (response) {
    if (!response || typeof response !== 'object') {
      return {};
    }

    return response?.data?.globalNavigationHeaderList?.items?.find(item => item.findACruiseCta)?.findACruiseCta;
  }

  function defineDomain(princesscomAppLinks) {
    if(!princesscomAppLinks) return $bookURL;

    if(princesscomAppLinks.includes('www')) {
      return $wwwURL;
    }

    if(princesscomAppLinks.includes('book')) {
      return $bookURL;
    }

    return $bookURL;
  }

  function normalizeLink({
    princesscomAppLinks,
    isExternal,
    externalUrl,
    externalPath,
    internalPath
  }) {
    const removeContentPrincess = (path) => {
      if (!path) return path;
      return path.replace(/\/content\/princess/, '');
    };

    if(externalPath) {
      return removeContentPrincess(externalPath);
    }

    const domain = defineDomain(princesscomAppLinks);
    let path = '';

    if(isExternal) {
      path = externalUrl ?? '';
    } else {
      path = internalPath?.["_path"] ?? '';
    }

    path = removeContentPrincess(path);
    return domain + path;
  }


  function clearInlineStyles ($element) {
    if (!$element) return;
    $element?.removeAttribute("style");
  }

  function markAsStandalone($element) {
    if (!$element) return;

    if(window.self === window.top) {
      $element?.classList?.add('standalone');
    } else {
      $element?.classList?.add('notStandalone');
    }
  }

  function setMinHeightForNav () {
    if(PAGE_WIDTH < BREAKPOINTS.xs) return;

    const $nav = getRootElement(PAGE_WIDTH).querySelector(`.${CLASSES.nav}`);
    const $expandedSubmenus = [...$nav.querySelectorAll(`.${CLASSES.submenu}.${CLASSES.open}`)];
    const $promo = $nav.querySelectorAll(`.${CLASSES.submenu}.${CLASSES.open} .${CLASSES.promo}`)
    const $header = $nav.querySelector(`.${CLASSES.header}`)

    clearInlineStyles($nav)
    $expandedSubmenus.forEach($el => clearInlineStyles($el));

    let expandedPromo = '';
    if($expandedSubmenus && $expandedSubmenus.length){
    expandedPromo = Array.from($expandedSubmenus).at(-1).querySelector(':scope > li > .nav-menu__promo');
    }

    const minHeight = Math.max(...[...$expandedSubmenus, expandedPromo].filter(Boolean).map($el => {
      return $el.offsetHeight;
    }))

    $nav.style.minHeight = minHeight + $header.offsetHeight +  "px";
    $expandedSubmenus.forEach($el => $el.style.minHeight = minHeight + "px");
  }

  function setLeftOffsetPromo () {
    if(PAGE_WIDTH < BREAKPOINTS.xs) return;

    const $nav = getRootElement(PAGE_WIDTH).querySelector(`.${CLASSES.nav}`);
    const $expandedSubmenus = [...$nav.querySelectorAll(`.${CLASSES.submenu}.${CLASSES.open}`)];
    const $promo = $nav.querySelector(`.${CLASSES.submenu}.${CLASSES.open} .${CLASSES.promo}`);

    if ($promo) {
      const offsetPromo = $expandedSubmenus.map(($el) => $el.offsetWidth).reduce((a, b) => a + b, 0);
      const navWidth = $nav.offsetWidth;

      $promo.style.width =  navWidth - offsetPromo + 'px';
      var firstSubmenuOffset = $expandedSubmenus.at(-1).offsetWidth;
      $promo.style.marginLeft = firstSubmenuOffset + "px";

    }
  }

  function setCloseBtnLeftOffset($header, $closeMenuBtns, firstChild, offset = 60) {
    if (!$header) return;
    $closeMenuBtns.forEach($el => {
      $el.style.left = $header.offsetWidth - firstChild.offsetWidth - offset + 'px';
    });
  }

  function closeAll() {
    const $nav = getRootElement(PAGE_WIDTH).querySelector(`.${CLASSES.nav}`);
    const $header = $nav.querySelector(`.${CLASSES.header}`);
    const $expandBtns = $nav.querySelectorAll(`[${ATTRIBUTES.ariaExpanded}="true"]`);
    const $AllOpenedMenus = $nav.querySelectorAll(`.${CLASSES.open}`);
    const $headerContainer = document.querySelector(CAPTAIN_CIRCLE_HEADER_CONTAINER);

    clearInlineStyles($nav);

    $expandBtns.forEach(btn => btn.setAttribute(ATTRIBUTES.ariaExpanded, "false"));
    $AllOpenedMenus.forEach(menu => menu.classList.remove(CLASSES.open));
    $nav.classList.remove(CLASSES.open);
    $header?.classList.remove(CLASSES.open);
    $headerContainer?.classList.remove(IS_MOBILE_MENU_OPENED);

    if($expandBtns && $expandBtns[0]) {
      $expandBtns[0].focus();
    }
  }

  function closeAllExpandedSubmenus($menu) {
    const $expandBtns = $menu.querySelectorAll(`[${ATTRIBUTES.ariaExpanded}="true"]`);
    const $openedSubmenus = $menu.querySelectorAll(`.${CLASSES.open}`);

    $expandBtns.forEach(btn => btn.setAttribute(ATTRIBUTES.ariaExpanded, "false"));
    $openedSubmenus.forEach(menu => menu.classList.remove(CLASSES.open));
  }

  function toggleExpandBtnAndMenu ({
    $expandBtn,
    $submenu,
    ariaExpandedValue
  }) {
    if (ariaExpandedValue === "true") {
      $expandBtn.setAttribute(ATTRIBUTES.ariaExpanded, "false");
      $submenu.classList.remove(CLASSES.open)
    } else {
      $expandBtn.setAttribute(ATTRIBUTES.ariaExpanded, "true");
      $submenu.classList.add(CLASSES.open);
    }
  }

  function handleClickExpandMenuBtn ($submenu, $expandBtn) {
    return function (event) {
      const $rootElement = getRootElement(PAGE_WIDTH);
      const $header = $rootElement.querySelector(`.${CLASSES.header}`);
      const $menu = $rootElement.querySelector(`.${CLASSES.menu}`);
      const $closeMenuBtns = $menu.querySelectorAll(`.${CLASSES.closeBtn}.${CLASSES.desktop}`);

      const ariaExpandedValue = $expandBtn.getAttribute(ATTRIBUTES.ariaExpanded);
      const isExpanded = ariaExpandedValue === "true";
      const firstChild = $submenu.firstElementChild;

      setCloseBtnLeftOffset($header, $closeMenuBtns, firstChild);

      if(isExpanded) {
        $header.classList.remove(CLASSES.open)
      } else {
        $header.classList.add(CLASSES.open)
      }

      closeAllExpandedSubmenus($menu);
      toggleExpandBtnAndMenu({ $expandBtn, $submenu, ariaExpandedValue });

      setLeftOffsetPromo();

      event.preventDefault();
      event.stopPropagation();
      const parentUL = $expandBtn.parentElement.querySelector("ul.".concat(CLASSES.submenu));
      const parentPromo = parentUL && Array.from(parentUL.querySelectorAll(`.${CLASSES.promo}`)).pop();
      const childPromo = $submenu.querySelector(`.${CLASSES.promo}`);
      const parentCloseBtn = parentUL && Array.from(parentUL.querySelectorAll(`.${CLASSES.closeBtn}`)).pop();
      const childCloseBtn = $submenu.querySelector(`.${CLASSES.closeBtn}`);
      if (!isExpanded) {
        expandSubmenu({
          $submenu,
          $header,
          $closeMenuBtns,
          firstChild,
          parentPromo,
          childPromo,
          parentCloseBtn,
          childCloseBtn,
          $expandBtn,
        });
      } else {
        collapseSubmenu({
          $submenu,
          $header,
          $closeMenuBtns,
          firstChild,
          parentPromo,
          childPromo,
          parentCloseBtn,
          childCloseBtn,
        });
      }
    };
  }

  function expandSubmenu({
    $submenu,
    $header,
    $closeMenuBtns,
    firstChild,
    parentPromo,
    childPromo,
    parentCloseBtn,
    childCloseBtn,
    $expandBtn,
  }) {
    const firstSubExpandBtn = $submenu.querySelector(`button.${CLASSES.expandBtn}.nav-menu__layer-2`);
    let firstSubSubmenu = null;
    if (firstSubExpandBtn) {
      firstSubExpandBtn.setAttribute(ATTRIBUTES.ariaExpanded, "true");
      firstSubSubmenu = firstSubExpandBtn.parentElement.querySelector(`.${CLASSES.submenu}`);
      if (firstSubSubmenu) {
        firstSubSubmenu.classList.add(CLASSES.open);
      }
  }
    setLeftOffsetPromo();
    setCloseBtnLeftOffset($header, $closeMenuBtns, firstSubSubmenu);
    if (parentPromo) parentPromo.style.display = "none";
    if (childPromo) childPromo.style.display = "flex";
    if (parentCloseBtn) parentCloseBtn.style.display = "none";
    if (childCloseBtn) childCloseBtn.style.display = "flex";
    setMinHeightForNav();
    trapFocus($submenu, $expandBtn);
  }

  function collapseSubmenu({
    $submenu,
    $header,
    $closeMenuBtns,
    firstChild,
    parentPromo,
    childPromo,
    parentCloseBtn,
    childCloseBtn,
  }) {
    if (parentPromo) parentPromo.style.display = "flex";
    if (childPromo) childPromo.style.display = "none";
    if (parentCloseBtn) parentCloseBtn.style.display = "flex";
    if (childCloseBtn) childCloseBtn.style.display = "none";
    const firstSubExpandBtn = $submenu.querySelector(`button.${CLASSES.expandBtn}.nav-menu__layer-2`);
    const firstSubSubmenu = firstSubExpandBtn? firstSubExpandBtn.parentElement.querySelector(`.${CLASSES.submenu}`): null;
    setMinHeightForNav();
    setCloseBtnLeftOffset($header, $closeMenuBtns, firstSubSubmenu);
    untrapFocus($submenu);
  }

  
  function handleClickExpandSubmenuBtn ($submenu, $expandBtn) {
    return function (event) {
      const $rootElement = getRootElement(PAGE_WIDTH);
      const $nav = getRootElement(PAGE_WIDTH).querySelector(`.${CLASSES.nav}`);
      const $header = $rootElement.querySelector(`.${CLASSES.header}`);
      const $menu = $rootElement.querySelector(`.${CLASSES.menu}`);
      const $closeMenuBtns = $menu.querySelectorAll(`.${CLASSES.closeBtn}.${CLASSES.desktop}`);
      const $expandedSubmenus = [...$nav.querySelectorAll(`.${CLASSES.submenu}.${CLASSES.open}`)];
      const firstChild = Array.from($expandedSubmenus).pop();
      $submenu.classList.contains('nav-menu__layer-4')? setCloseBtnLeftOffset($header, $closeMenuBtns, firstChild,390): setCloseBtnLeftOffset($header, $closeMenuBtns, firstChild);
      const ariaExpandedValue = $expandBtn.getAttribute(ATTRIBUTES.ariaExpanded);
      closeAllExpandedSubmenus($expandBtn.parentElement.parentElement);
      toggleExpandBtnAndMenu({ $expandBtn, $submenu, ariaExpandedValue });

      setLeftOffsetPromo();

      event.preventDefault();
      event.stopPropagation();
      const parentUL = $expandBtn.closest("li.nav-menu__submenuItem")?.closest("ul.nav-menu__submenu"),
      parentPromo = parentUL && Array.from(parentUL.querySelectorAll(`.${CLASSES.promo}`)).pop(),
      childPromo = $submenu.querySelector(`.${CLASSES.promo}`),
      parentCloseBtn = parentUL && Array.from(parentUL.querySelectorAll(`.${CLASSES.closeBtn}`)).pop(),
      childCloseBtn = $submenu.querySelector(`.${CLASSES.closeBtn}`);

      if (ariaExpandedValue !== "true") { 
        (function(){
          if(parentPromo){parentPromo.style.display="none";}
          if(childPromo){childPromo.style.display="flex";}
          if(parentCloseBtn){parentCloseBtn.style.display="none";}
          if(childCloseBtn){childCloseBtn.style.display="flex";}
          setMinHeightForNav();
        trapFocus($submenu,$expandBtn);
        })()
      } else {
          if(parentPromo){parentPromo.style.display="flex";}
          if(childPromo){childPromo.style.display="none";}
          if(parentCloseBtn){parentCloseBtn.style.display="flex";}
          if(childCloseBtn){childCloseBtn.style.display="none";}
          setMinHeightForNav();
          $submenu.classList.contains('nav-menu__layer-4')? setCloseBtnLeftOffset($header, $closeMenuBtns, firstChild,390): setCloseBtnLeftOffset($header, $closeMenuBtns, firstChild);     
          untrapFocus($submenu);
      }
    }
  }

  function handleClickBackBtn ($submenu, $expandBtn) {
    return function (event) {
      $expandBtn.setAttribute(ATTRIBUTES.ariaExpanded, "false");
      $submenu.classList.remove(CLASSES.open);
      untrapFocus($submenu);

      event.preventDefault();
      event.stopPropagation();
    }
  }

  function handleClickCloseBtn (event) {
    closeAll(event);
    const $burgerBtn = getRootElement(PAGE_WIDTH).querySelector(`.${CLASSES.burgerBtn}`);
    $burgerBtn?.classList.remove(CLASSES.open);
    $burgerBtn?.focus();
    event.preventDefault();
    event.stopPropagation();
  }

  function handleClickBurgerBtn ($menu) {
    return function (event) {
      const $burgerBtn = this;
      const $nav = getRootElement(PAGE_WIDTH).querySelector(`.${CLASSES.nav}`);
      const $headerContainer = document.querySelector(CAPTAIN_CIRCLE_HEADER_CONTAINER);

      $nav.classList.add(CLASSES.open);
      $burgerBtn.classList.add(CLASSES.open);
      $menu.classList.add(CLASSES.open);
      $headerContainer?.classList.add(IS_MOBILE_MENU_OPENED);
      const firstFocusable = $nav.querySelector('a, button');
      firstFocusable?.focus();  
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function createElement({
    tag,
    classes = [],
    attributes = {},
    eventListeners = {},
    children = [],
    innerHTML,
    textContent,
  }) {
    const $element = document.createElement(tag);
    if (classes && Array.isArray(classes)) $element.classList.add(...classes);
    if (attributes && typeof attributes === 'object') Object.entries(attributes).forEach(([att, value]) => {
      $element.setAttribute(att, value);
    });
    if (eventListeners && typeof eventListeners === 'object') Object.entries(eventListeners).forEach(([eventName, handler]) => {
      $element.addEventListener(eventName, handler);
    });
    if (children && Array.isArray(children)) children.forEach((child => $element.appendChild(child)));
    if (textContent) $element.textContent = textContent;
    if (innerHTML) $element.innerHTML = innerHTML;

    return $element;
  }

  function createSearchBtn({
    textLink = '',
  }) {
    return createElement({
      tag: 'div',
      classes: [CLASSES.searchBtnWrapper],
      children: [  createElement({
        tag: 'a',
        classes: [CLASSES.searchBtn],
        attributes: {
          href: $wwwURL + '/cruise-search/cruises/',
          [ATTRIBUTES.dataTrack]: "header",
          [ATTRIBUTES.dataTrackId]: textLink?.toLowerCase().replace(/\s+/g, '-'),
          "aria-label": textLink
        },
        textContent: textLink,
      })]
    });
  }

  function createLogo() {
    return createElement({
      tag: 'h1',
      attributes: {
        [ATTRIBUTES.dataTrack]: "header",
        [ATTRIBUTES.dataTrackId]: "princess-logo",
      },
      classes: [CLASSES.logo],
      innerHTML: `<a href= "${$wwwURL}" aria-label = "Princess Cruises Home Page">
      <svg role="img" aria-labelledby="pcl-logo princess-link" width="${PAGE_WIDTH >= BREAKPOINTS.xs ? 336 : 261}" height="${PAGE_WIDTH >= BREAKPOINTS.xs ? 90 : 70}" viewBox="0 0 336 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title id="pcl-logo">pcl logo</title>
      <desc id="princess-link">princess homepage</desc>
      <path d="M0 0H335.501V25.9978C335.501 61.344 306.847 89.9978 271.501 89.9978H0V0Z" fill="#003595"></path>
      <path d="M283.215 32.474C283.215 31.2697 284.123 30.3945 285.357 30.3945C286.592 30.3945 287.5 31.2697 287.5 32.474C287.5 33.6783 286.592 34.5304 285.357 34.5304C284.123 34.5304 283.215 33.6323 283.215 32.474ZM287.057 32.451C287.057 31.4355 286.358 30.7977 285.357 30.7977C284.356 30.7977 283.657 31.4355 283.657 32.451C283.657 33.4665 284.357 34.1299 285.38 34.1299C286.403 34.1299 287.057 33.4435 287.057 32.451ZM284.472 32.1193V31.5299C284.472 31.387 284.379 31.3641 284.193 31.3641C284.17 31.3641 284.145 31.3411 284.145 31.2926C284.145 31.2212 284.193 31.1982 284.261 31.1982H284.354C284.399 31.1982 284.585 31.2212 284.749 31.2212C284.958 31.2212 285.051 31.1982 285.284 31.1982C285.682 31.1982 286.31 31.2697 286.31 31.8361C286.31 32.0734 286.217 32.2622 285.823 32.5454L286.243 33.0404C286.544 33.395 286.592 33.395 286.64 33.395C286.688 33.395 286.71 33.418 286.71 33.4665C286.71 33.5379 286.688 33.5609 286.502 33.5609C286.197 33.5609 285.943 33.5838 285.594 33.1118L285.267 32.6628H284.988V32.8745C284.988 33.3006 285.01 33.3466 285.033 33.3695C285.081 33.3925 285.196 33.3925 285.267 33.3925C285.315 33.3925 285.337 33.3925 285.337 33.4639C285.337 33.5354 285.289 33.5583 285.244 33.5583H285.151C285.103 33.5583 284.895 33.5354 284.779 33.5354C284.709 33.5354 284.477 33.5583 284.429 33.5583H284.314C284.266 33.5583 284.15 33.5354 284.15 33.4639C284.15 33.418 284.173 33.3925 284.221 33.3925C284.429 33.3925 284.455 33.3925 284.477 33.2496C284.5 33.1322 284.477 32.9664 284.477 32.6347V32.1142L284.472 32.1193ZM284.985 32.3566C285.056 32.4051 285.217 32.428 285.312 32.428C285.382 32.428 285.453 32.428 285.521 32.3796C285.636 32.3081 285.73 32.1678 285.73 31.9764C285.73 31.6932 285.521 31.4559 285.194 31.4559C285.171 31.4559 285.03 31.4559 284.985 31.5044V32.354V32.3566Z" fill="white"></path>
      <path d="M112.17 30.6289C111.355 30.6289 110.43 30.6595 109.532 30.6876C108.69 30.7157 107.872 30.7412 107.191 30.7412C106.788 30.7412 106.175 30.7208 105.463 30.7003C104.503 30.6697 103.306 30.6289 102.247 30.6289C101.938 30.6289 101.211 30.6289 101.211 31.2489C101.211 31.6622 101.503 31.8715 102.076 31.8715C102.604 31.8715 103.125 31.9123 103.351 31.9735C104.271 32.1878 104.543 32.5859 104.611 33.8361C104.679 35.02 104.679 36.0431 104.679 41.7201V48.2799C104.679 51.6912 104.679 54.6355 104.51 56.1792C104.372 57.2737 104.208 57.8861 103.728 57.9881C103.472 58.0494 103.069 58.1285 102.556 58.1285C101.87 58.1285 101.726 58.4449 101.726 58.7102C101.726 58.9552 101.852 59.371 102.695 59.371C103.482 59.371 104.508 59.3353 105.415 59.3021C106.089 59.2792 106.683 59.2588 107.02 59.2588C107.357 59.2588 107.89 59.2741 108.544 59.2945C109.612 59.3277 110.945 59.371 112.343 59.371C113.208 59.371 113.276 58.8659 113.276 58.7102C113.276 58.5342 113.196 58.1285 112.446 58.1285C111.954 58.1285 111.212 58.0545 110.734 57.983C109.939 57.8682 109.741 57.2993 109.633 56.2225C109.464 54.6355 109.464 51.6886 109.464 48.2799V33.3743C109.464 33.0451 109.54 32.9405 109.552 32.9354C109.786 32.8512 110.229 32.8027 110.794 32.8027C111.488 32.8027 112.831 32.9813 114.033 34.178C115.771 35.8619 115.972 38.0562 115.972 39.5615C115.972 43.1948 113.457 45.4248 111.652 45.4248C111.217 45.4248 110.41 45.4248 110.41 46.1188C110.41 46.5959 110.85 46.6903 111.043 46.7337C111.219 46.772 111.524 46.7771 111.823 46.7771C116.88 46.7771 120.549 42.8631 120.549 37.4719C120.549 35.5532 119.646 33.7621 118.751 32.8385C118.215 32.2925 116.586 30.6289 112.165 30.6289H112.17Z" fill="white"></path>
      <path d="M192.827 30.6302C191.612 30.6302 190.599 30.6838 189.925 30.717C189.621 30.7323 189.394 30.7425 189.268 30.7425C188.974 30.7425 188.534 30.7246 187.996 30.7068C187.123 30.6736 186.037 30.6302 184.878 30.6302C184.42 30.6302 183.653 30.6302 183.653 31.2502C183.653 31.6635 183.942 31.8728 184.516 31.8728C184.978 31.8728 185.838 31.8728 186.329 32.0718C187.02 32.3677 187.355 32.9061 187.39 35.1718L187.742 51.3812C187.289 50.9066 186.452 50.0034 185.454 48.9292C183.686 47.0259 181.486 44.6581 180.07 43.2012C174.52 37.5395 168.882 31.3038 168.827 31.2451C168.706 31.1124 168.595 30.9874 168.492 30.8726C168.045 30.3649 167.723 30 167.278 30C166.526 30 166.526 31.1277 166.526 31.5487L166.199 53.6112C166.161 56.9229 165.988 57.7369 165.278 57.9614C164.758 58.1145 164.079 58.1349 163.722 58.1349C163.01 58.1349 162.859 58.4513 162.859 58.7166C162.859 59.3774 163.561 59.3774 163.938 59.3774C165.276 59.3774 166.516 59.3213 167.255 59.2881C167.552 59.2754 167.763 59.2652 167.859 59.2652C168.097 59.2652 168.429 59.2779 168.859 59.2958C169.687 59.329 170.821 59.3774 172.357 59.3774C172.662 59.3774 173.471 59.3774 173.471 58.7166C173.471 58.3313 173.17 58.1349 172.574 58.1349C172.056 58.1349 171.382 58.1068 170.781 57.8925C170.318 57.7241 169.775 57.1322 169.697 54.0168L169.315 39.0066C169.433 39.1393 169.571 39.2949 169.729 39.4735C171.253 41.1932 174.424 44.7704 177.565 47.9673C179.097 49.5263 180.774 51.2562 182.376 52.9121C184.709 55.3206 186.912 57.5965 188.268 58.9207C188.713 59.38 189.191 59.8265 189.701 59.8265C190.453 59.8265 190.453 58.8161 190.453 58.39L190.853 34.8758C190.89 32.6714 191.235 32.1994 191.984 31.9774C192.387 31.8779 192.646 31.8779 193.005 31.8779C193.817 31.8779 193.938 31.4875 193.938 31.2553C193.938 30.6353 193.186 30.6353 192.824 30.6353L192.827 30.6302Z" fill="white"></path>
      <path d="M220.196 51.8746C219.628 51.8746 219.542 52.3492 219.452 52.8442C219.314 53.482 218.861 54.5179 218.285 55.1788C216.874 56.85 214.948 57.1663 211.885 57.1663C204.311 57.1663 200.783 49.4201 200.783 44.1845C200.783 39.8318 201.812 36.8313 204.017 34.7416C205.667 33.1954 207.701 32.5065 210.62 32.5065C213.54 32.5065 216.537 33.397 217.752 34.7289C218.549 35.5836 219.047 36.7955 219.082 37.9616C219.082 38.2907 219.082 39.0663 219.726 39.0663C220.37 39.0663 220.413 38.3621 220.44 37.9513C220.478 37.5584 220.485 36.8211 220.496 36.0429C220.506 35.2902 220.513 34.5094 220.548 33.9149C220.591 33.1342 220.649 32.6622 220.687 32.3509C220.712 32.1264 220.729 31.9758 220.729 31.8508C220.729 31.6952 220.672 31.1874 219.935 31.1211C219.384 31.0624 218.806 30.9451 218.192 30.8226C217.606 30.7027 216.998 30.5802 216.329 30.4883C214.747 30.2766 213.354 30.1133 211.053 30.1133C206.039 30.1133 202.35 31.3941 199.443 34.1395C195.437 37.9258 195.125 43.0721 195.125 44.5571C195.125 49.2466 196.664 53.0177 199.699 55.7631C202.848 58.585 206.846 59.899 212.28 59.899C214.448 59.899 217.322 59.6668 218.894 59.0187C219.57 58.7304 219.786 58.4829 219.995 57.7532C220.355 56.4979 220.802 53.2269 220.802 52.7166C220.802 51.9563 220.377 51.8746 220.196 51.8746Z" fill="white"></path>
      <path d="M240.554 53.1381C240.041 53.1381 239.963 53.6178 239.911 53.9393C239.689 55.4038 239.325 56.0927 238.563 56.4856C237.761 56.9015 236.385 56.9015 235.565 56.9015C232.243 56.9015 231.917 56.3989 231.856 54.0464C231.834 53.2836 231.844 51.3623 231.851 49.8161C231.854 49.1961 231.859 48.6476 231.859 48.2802V45.3358C231.859 45.2975 231.859 45.2694 231.861 45.249C232.865 45.249 235.895 45.2899 236.466 45.3587C237.685 45.5067 237.969 46.0655 238.088 46.5885C238.155 46.9177 238.176 47.2545 238.193 47.553C238.201 47.6755 238.208 47.7903 238.216 47.8719C238.216 48.2546 238.44 48.4919 238.797 48.4919C239.378 48.4919 239.378 47.7979 239.378 47.4994C239.378 47.3616 239.405 46.8743 239.438 46.3411C239.466 45.869 239.496 45.3613 239.511 45.022C239.599 43.7692 239.687 43.0777 239.735 42.7078C239.762 42.4935 239.777 42.3659 239.777 42.2842C239.777 41.853 239.501 41.7 239.264 41.7C238.975 41.7 238.799 41.9245 238.56 42.2307L238.515 42.2919C238.279 42.5853 237.841 42.6772 237.109 42.7461C236.634 42.792 234.73 42.82 231.869 42.82C231.866 42.792 231.864 42.7537 231.864 42.695V33.2623C231.864 33.224 231.864 33.196 231.869 33.1755C232.701 33.1781 235.988 33.2521 236.501 33.321C238.062 33.5302 238.306 33.9129 238.502 34.4793C238.646 34.8646 238.684 35.4387 238.684 35.7193C238.684 36.2552 238.88 36.5256 239.264 36.5256C239.488 36.5256 239.777 36.4133 239.875 35.8724C239.921 35.5688 239.963 34.7753 239.999 34.1349C240.016 33.8032 240.031 33.5225 240.044 33.3873C240.112 32.2468 240.207 31.6829 240.263 31.3462C240.293 31.1625 240.311 31.0451 240.311 30.9481C240.311 30.3894 239.974 30.3281 239.83 30.3281C239.687 30.3281 239.536 30.3817 239.41 30.4276C239.35 30.4506 239.295 30.471 239.224 30.4863C238.943 30.5654 238.296 30.6496 237.854 30.7032C237.29 30.7364 231.864 30.7389 229.555 30.7389C229.148 30.7389 228.512 30.7108 227.777 30.6777L227.463 30.6624C227.056 30.6624 226.621 30.6522 226.173 30.6445C225.705 30.6343 225.23 30.6241 224.767 30.6241C224.463 30.6241 223.754 30.6241 223.754 31.2441C223.754 31.6574 224.038 31.8667 224.599 31.8667C225.109 31.8667 225.612 31.9075 225.831 31.9687C226.719 32.1805 226.98 32.5811 227.046 33.8313C227.111 35.0177 227.111 36.0408 227.111 41.7178V48.2776C227.111 51.6889 227.111 54.6333 226.948 56.1795C226.814 57.274 226.656 57.8864 226.196 57.9884C225.949 58.0497 225.562 58.1288 225.064 58.1288C224.355 58.1288 224.249 58.4936 224.249 58.7105C224.249 58.9554 224.373 59.3713 225.195 59.3713C225.519 59.3713 225.891 59.3535 226.276 59.3356C226.681 59.3177 227.096 59.2973 227.501 59.2973C228.29 59.2616 229.017 59.2616 229.379 59.2616H229.382C230.312 59.2616 231.28 59.2922 232.834 59.3739L233.798 59.3994C235.057 59.4351 236.624 59.4836 238.593 59.4836C239.855 59.4836 240.376 59.4836 240.663 58.2946C240.836 57.5266 241.103 54.9752 241.103 54.0924C241.103 53.7122 241.103 53.1381 240.557 53.1381H240.554Z" fill="white"></path>
      <path d="M255.238 41.8704L254.227 41.0896C251.076 38.6275 250.5 37.4257 250.5 35.9485C250.5 33.7899 252.079 32.3943 254.526 32.3943C256.686 32.3943 257.687 33.374 258.253 34.114C258.984 35.0452 259.133 36.15 259.133 36.395C259.133 37.1859 259.482 37.3518 259.774 37.3518C260.453 37.3518 260.453 36.4715 260.453 35.9485C260.453 33.8945 260.526 32.7693 260.569 32.0983C260.586 31.8202 260.599 31.6237 260.599 31.4783C260.599 30.9195 260.071 30.7996 259.885 30.7562C258.808 30.4577 257.277 30.1133 254.996 30.1133C249.906 30.1133 246.351 33.1265 246.351 37.4411C246.351 40.7069 247.985 43.414 251.818 46.4936L253.482 47.8357C256.349 50.1499 256.925 51.7471 256.925 53.5765C256.925 55.4977 255.323 57.5414 252.353 57.5414C250.905 57.5414 248.34 57.0796 247.447 53.9821C247.261 53.3366 247.133 52.5865 247.133 52.1629C247.133 51.4026 246.781 51.2419 246.489 51.2419C245.855 51.2419 245.797 52.14 245.775 52.4793L245.767 52.5941C245.725 53.2958 245.594 55.4365 245.594 57.3781C245.594 58.2941 245.762 58.5952 246.449 58.9064C247.98 59.603 249.597 59.899 251.85 59.899C254.219 59.899 256.153 59.3836 257.762 58.3222C260.833 56.2606 261.29 53.2244 261.29 51.6016C261.29 47.9199 259.651 45.2842 255.24 41.8704H255.238Z" fill="white"></path>
      <path d="M274.781 41.8704L273.77 41.0896C270.617 38.6275 270.041 37.4257 270.041 35.9485C270.041 33.7899 271.62 32.3943 274.067 32.3943C276.227 32.3943 277.228 33.374 277.794 34.1114C278.523 35.0452 278.672 36.15 278.672 36.395C278.672 37.1859 279.024 37.3518 279.315 37.3518C279.994 37.3518 279.994 36.4715 279.994 35.9485C279.994 33.8945 280.065 32.7693 280.107 32.0983C280.125 31.8202 280.138 31.6237 280.138 31.4783C280.138 30.9195 279.612 30.7996 279.423 30.7562C278.345 30.4577 276.813 30.1133 274.532 30.1133C269.443 30.1133 265.887 33.1265 265.887 37.4411C265.887 40.7069 267.521 43.414 271.351 46.4936L273.019 47.8357C275.885 50.1499 276.459 51.7471 276.459 53.5765C276.459 55.4977 274.857 57.5414 271.887 57.5414C270.438 57.5414 267.874 57.0796 266.978 53.9821C266.792 53.3366 266.664 52.5865 266.664 52.163C266.664 51.4026 266.314 51.2419 266.023 51.2419C265.389 51.2419 265.331 52.14 265.309 52.4793L265.301 52.6095C265.253 53.3851 265.125 55.4492 265.125 57.3807C265.125 58.2966 265.293 58.5977 265.98 58.909C267.511 59.6055 269.126 59.9015 271.381 59.9015C273.75 59.9015 275.684 59.3861 277.293 58.3247C280.364 56.2631 280.824 53.2295 280.824 51.6042C280.824 47.925 279.185 45.2868 274.774 41.8729L274.781 41.8704Z" fill="white"></path>
      <path d="M159.87 58.1336C159.369 58.1336 158.633 58.0596 158.157 57.9881C157.32 57.8682 157.124 57.386 157.023 56.4216C156.887 54.832 156.887 51.9412 156.887 48.285V41.7252C156.887 36.0482 156.887 35.0251 156.955 33.8386C157.021 32.5782 157.275 32.1241 157.994 31.9786C158.386 31.9072 158.645 31.8715 158.975 31.8715C159.525 31.8715 159.804 31.6495 159.804 31.2132C159.804 30.6289 159.05 30.6289 158.801 30.6289C158.077 30.6289 157.134 30.6646 156.289 30.6952C155.61 30.7208 154.996 30.7412 154.614 30.7412C154.151 30.7412 153.437 30.7182 152.675 30.6927C151.795 30.6621 150.85 30.6289 150.151 30.6289C149.821 30.6289 149.047 30.6289 149.047 31.2132C149.047 31.6495 149.326 31.8715 149.876 31.8715C150.337 31.8715 150.726 31.9174 151.046 32.0118C151.496 32.1241 151.923 32.4226 151.999 33.8386C152.067 35.0225 152.067 36.0456 152.067 41.7226V48.2824C152.067 51.9387 152.067 54.8243 151.896 56.3782C151.79 57.4804 151.594 57.8861 151.114 57.9907C150.895 58.0443 150.538 58.1106 150.093 58.1234H149.167C148.911 58.1183 148.647 58.0877 148.307 58.0188C147.804 57.9116 146.467 57.6258 144.651 55.5821C142.911 53.5971 140.934 50.8926 138.435 47.4685L137.371 46.0116C140.477 43.2229 141.804 40.702 141.804 37.6224C141.804 34.8286 140.2 32.9099 139.355 32.2874C137.389 30.8279 134.974 30.6289 132.872 30.6289C132.352 30.6289 131.459 30.657 130.546 30.685C129.598 30.7131 128.627 30.7437 128.031 30.7437C127.755 30.7437 127.264 30.7284 126.663 30.708C125.678 30.6748 124.451 30.6315 123.329 30.6315C123.02 30.6315 122.293 30.6315 122.293 31.2515C122.293 31.6648 122.582 31.874 123.156 31.874C123.681 31.874 124.202 31.9148 124.433 31.9786C125.353 32.1929 125.625 32.591 125.693 33.8412C125.761 35.0251 125.761 36.0482 125.761 41.7252V48.285C125.761 51.6963 125.761 54.6406 125.592 56.1843C125.454 57.2788 125.29 57.8886 124.81 57.9933C124.556 58.0545 124.159 58.1361 123.641 58.1361C122.954 58.1361 122.811 58.4525 122.811 58.7179C122.811 58.9628 122.937 59.3787 123.779 59.3787C124.622 59.3787 125.698 59.3379 126.58 59.3073C127.189 59.2843 127.705 59.2664 127.969 59.2664C128.14 59.2664 128.542 59.2792 129.073 59.2945C130.116 59.3277 131.693 59.3787 133.016 59.3787C133.858 59.3787 133.984 58.9654 133.984 58.7179C133.984 58.45 133.803 58.1361 133.292 58.1361C132.887 58.1361 132.143 58.0596 131.65 57.9907C130.853 57.8759 130.654 57.2967 130.549 56.1919C130.378 54.6432 130.378 51.681 130.378 48.2492L130.365 47.716L133.36 47.79C133.576 47.79 133.669 47.8257 133.76 47.9456C134.009 48.2595 134.653 49.2494 135.397 50.4001C135.95 51.2523 136.566 52.204 137.145 53.0689C139.169 56.0873 140.467 57.7789 141.94 58.6337C142.908 59.2001 143.836 59.3812 145.755 59.3812H150.09C150.877 59.3812 151.906 59.3455 152.814 59.3124C153.487 59.2894 154.078 59.269 154.418 59.269C154.778 59.269 155.326 59.2868 155.992 59.3073C157.058 59.3404 158.389 59.3812 159.774 59.3812C160.639 59.3812 160.707 58.8761 160.707 58.7204C160.707 58.5444 160.627 58.1387 159.877 58.1387L159.87 58.1336ZM137.195 39.4876C137.195 42.83 135.993 44.2817 135.279 44.8533C134.718 45.2921 134.333 45.4273 133.013 45.4273C132.07 45.4273 131.107 45.2921 130.521 45.0803C130.418 45.0319 130.375 45.0115 130.375 44.667V33.336C130.375 33.1217 130.403 33.114 130.491 33.086C130.86 32.9635 131.658 32.9507 132.223 32.9507C134.072 32.9507 137.197 34.326 137.197 39.485L137.195 39.4876Z" fill="white"></path>
      <path d="M54.5186 42.008C62.2211 46.8123 63.4407 46.6057 69.8431 42.3396C78.0912 36.854 82.5975 44.141 88.2806 44.9192C91.2706 45.3248 93.8909 43.6077 93.8909 43.6077C87.7777 54.8698 79.2354 49.471 72.3301 46.1796C65.8095 43.0821 61.4491 52.1092 54.5513 50.938C54.3451 50.8921 54.2219 51.0962 54.3753 51.1906C62.5279 56.2731 65.9076 53.7344 69.4181 51.3973C77.9026 45.7586 82.7157 53.3517 88.1851 54.1018C91.1725 54.5126 93.8004 52.7929 93.8004 52.7929C86.8096 65.6676 77.8749 57.7096 74.1557 55.967C71.2161 54.5968 69.6318 52.8746 63.0358 56.1098C57.2747 58.9471 49.6452 61.2995 42.6519 59.1665C42.6519 59.1665 42.6242 59.1588 42.5941 59.141C43.4013 56.8753 44.6536 53.9003 46.8162 53.9335C47.4474 53.936 50.9 54.1682 51.2596 54.1121C51.6745 54.0559 51.9461 53.7548 52.0191 53.4283C52.1875 52.6679 51.8807 52.4919 51.8481 52.2469C51.8179 52.0046 52.0568 51.9255 52.2554 51.7622C52.5823 51.4968 52.6125 51.2978 52.5396 51.0733C52.4767 50.8794 52.0367 50.8181 51.8908 50.7339C51.745 50.6472 51.7852 50.3946 52.0191 50.364C53.1984 50.2058 53.1356 49.5705 52.9998 49.3459C52.517 48.458 53.2688 48.3024 53.5455 48.2335C53.9201 48.1442 54.5966 47.8814 54.4005 47.2129C54.1641 46.4092 53.9327 45.8147 53.7718 45.1258C53.5103 44.0159 53.2362 43.0387 53.4952 42.4009C53.8347 41.5614 54.1892 41.7987 54.5136 42.0028M88.4994 35.341C81.5162 34.3842 77.7039 28.3832 70.253 33.3381C65.7165 36.359 64.014 38.8901 55.0367 33.2896C50.5505 30.4907 47.8774 30.2228 45.325 30.0544C37.2579 29.5237 30.4029 35.8819 30.0182 44.1869C29.812 48.6494 31.366 52.6016 34.3434 55.4286C34.7055 55.7322 35.1104 55.6659 35.3015 55.2959L35.3845 55.0918L39.9914 43.8476C39.9914 43.8476 42.4884 37.2393 48.6469 39.306C50.6284 39.9642 52.2655 40.6123 53.7366 41.0665C57.2521 42.161 59.8271 42.1815 63.8883 38.9079C65.7366 37.4179 68.7894 35.3333 72.75 37.1883C78.2873 39.7703 87.5313 46.1719 94.1247 34.0423C94.1247 34.0423 91.4894 35.7569 88.5044 35.3487L88.4994 35.341Z" fill="white"></path>
    </svg> </a>`
    });
  }

  function createBurgerBtn($menu) {
    return createElement({
      tag: 'button',
      attributes: {
        [ATTRIBUTES.dataTrack]: "header",
        [ATTRIBUTES.dataTrackId]: "menu",
        "aria-label": "menu"
      },
      classes: [CLASSES.burgerBtn],
      children: [
        createElement({tag: 'div', innerHTML: `
        <svg aria-hidden="true" focusable="false" width="25" height="16" viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.8473 8.47656H0.84729V7.47656H24.8473V8.47656Z" fill="#020215"/>
        <path d="M24.8473 1.45752H0.84729V0.45752H24.8473V1.45752Z" fill="#020215"/>
        <path d="M24.8473 15.5H0.84729V14.5H24.8473V15.5Z" fill="#020215"/>
      </svg>
        `}),
        createElement({
          tag: 'div',
          classes: [CLASSES.burgerBtnText],
          textContent: 'Menu'
        })
      ],
      eventListeners: {
        'click': handleClickBurgerBtn($menu)
      }
    })
  }

  function createBackBtn($submenu, $expandBtn) {
    if(!$submenu || !$expandBtn) return;

    return createElement({
      tag: 'button',
      attributes: {
        [ATTRIBUTES.dataTrack]: "primaryNav",
        [ATTRIBUTES.dataTrackId]: "back",
        "aria-label": "back button"
      },
      classes: [CLASSES.menuControlPanelBackBtn],
      eventListeners: { 'click': handleClickBackBtn($submenu, $expandBtn) },
      children: [
        createElement({tag:'div', innerHTML: `<svg aria-hidden="true" focusable="false" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.15271 1L1.15271 7L7.15271 13" stroke="#020215" stroke-linejoin="round"/>
        </svg>
        `}),
        createElement({tag:'div',  classes: [CLASSES.menuControlPanelBackBtnText],  textContent: "Back"}),
      ]


    })
  }

    function trapFocus($submenu, $expandBtn) {
    const focusableSelectors = 'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
    let focusableElements = Array.from($submenu.querySelectorAll(focusableSelectors));
    focusableElements = focusableElements.filter(
      e => !e.classList.contains("nav-menu__menuControlPanelBackBtn") &&
           !e.classList.contains("nav-menu__menuControlPanelCloseBtn")
    );  
      if (focusableElements.length === 0) return;
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

  function handleKeyDown(e) {
        if (e.key === 'Tab') {
            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                  e.preventDefault();
                    firstFocusable.focus();
                }
            }
        } else if (e.key === 'Escape') {
            closeAll();
            $expandBtn.focus();
        }
    }
    $submenu.addEventListener('keydown', handleKeyDown);   
    firstFocusable.focus();   
    $submenu._trapFocusHandler = handleKeyDown;
}



function untrapFocus($submenu) {
    if (!$submenu || !$submenu._trapFocusHandler) return;
    $submenu.removeEventListener('keydown', $submenu._trapFocusHandler);
    delete $submenu._trapFocusHandler;
}

  function createCloseBtn(classes = []) {
    return createElement({ 
    tag: 'button', 
    attributes: {
      [ATTRIBUTES.dataTrack]: "header",
      [ATTRIBUTES.dataTrackId]: "close",
      "aria-label": "close button"
    },
    classes: classes, eventListeners: { 'click': handleClickCloseBtn },
    children: [
      createElement({ tag: 'div', innerHTML: `<svg aria-hidden="true" focusable="false" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43539 7.25485L14.5765 1.11373L13.9227 0.459961L7.78161 6.60108L1.77185 0.591313L1.11808 1.24509L7.12784 7.25485L0.84729 13.5354L1.50106 14.1892L7.78161 7.90862L14.1935 14.3205L14.8473 13.6668L8.43539 7.25485Z" fill="#020215"/>
      </svg>` }),
      createElement({ tag: 'div', textContent: "Close", classes: [CLASSES.closeBtnText] }),
    ]

  })
  }

  function createMenuControlPanel({
    menuTextLink,
    $submenu,
    $expandBtn
  }) {
    return createElement({
      tag: 'div',
      classes: [CLASSES.menuControlPanel],
      children: [
        createBackBtn($submenu, $expandBtn),
        createElement({ tag: 'span', classes: [CLASSES.menuControlPanelTitle], textContent: menuTextLink }),
        createCloseBtn([CLASSES.menuControlPanelCloseBtn]),
      ]
    });
  }

  function createPromo(promotionpath) {
    if (!promotionpath) return;

    const $promoImg = createElement({
      tag: 'img', classes: [CLASSES.promoImg], attributes: {
        'src': `${$wwwURL}${promotionpath?.image?._path}`,
        'alt': promotionpath?.title
      }
    });
    const $promoTitle = createElement({ tag: 'div', classes: [CLASSES.promoTitle], textContent: promotionpath?.title });
    const $promoDescription = createElement({ tag: 'div', classes: [CLASSES.promoDescription], innerHTML: promotionpath?.description?.html });
    const $promoLink = createElement({
      tag: 'a',
      classes: [CLASSES.promoLink],
      textContent: promotionpath.ctaText,
      attributes: {
        href: normalizeLink({
          princesscomAppLinks: promotionpath.princesscomAppLinks || "www",
          isExternal: promotionpath.isExternal,
          externalUrl: promotionpath.externalUrl,
          externalPath: promotionpath.externalPath,
          internalPath: promotionpath.internalPath
        }),
        [ATTRIBUTES.ariaLabel]: `Learn more ${promotionpath?.title || ''}`,
        [ATTRIBUTES.dataComponentLevel]: "primaryNav",
        [ATTRIBUTES.dataTrack]: promotionpath?.title?.toLowerCase().replace(/\s+/g, '-'),
        [ATTRIBUTES.dataTrackId]: promotionpath?.ctaText?.toLowerCase().replace(/\s+/g, '-'),
        role: "menuitem",
        "tabindex": "0" 
      }
    });

    return createElement({
      tag: 'div', classes: [CLASSES.promo], children: [
        $promoImg,
        $promoTitle,
        $promoDescription,
        $promoLink,
      ]
    });
  }

  function createMenu({
    menuLinks,
    ulClasses = [],
    liClasses = [],
    layer = 1,
    promotionpath,
  }) {
    if (!menuLinks || !Array.isArray(menuLinks)) return;
    const $ul = createElement({ tag: 'ul', classes: ulClasses, attributes: { role: "menu" }});
    let $promo;

    for(let i = 0; i < menuLinks.length; i++) {
      const $li = createElement({ tag: 'li', classes: liClasses, attributes: { role: "none" } });
      const menuLink = menuLinks[i];

      if (promotionpath) {
        $promo = promotionpath
      }

      if (menuLink.sublink && menuLink.sublink?.length) {
        const submenuId = `submenu-${layer}-${i}`;
        const $submenu = createMenu({
          menuLinks: menuLink.sublink,
          ulClasses: [CLASSES.submenu, CLASSES.layer + '-' + (layer + 1)],
          liClasses: [CLASSES.submenuItem, CLASSES.layer + '-' + (layer + 1)],
          layer: layer + 1,
          promotionpath:  (menuLink.haspromotion ? menuLink.promotionpath : undefined) || $promo
        });
        $submenu.setAttribute('id', submenuId);
        const $expandBtn = createElement({
          tag: 'button', attributes: {
            [ATTRIBUTES.ariaExpanded]: "false",
            ...(layer !== 1 && { [ATTRIBUTES.dataComponentLevel]: "primaryNav-dropdown" }),
            [ATTRIBUTES.dataTrack]: layer === 1 ? "primaryNav-dropdown" : menuLink?.menuTextLink?.toLowerCase().replace(/\s+/g, '-') + '-dropdown',
            [ATTRIBUTES.dataTrackId]: menuLink?.menuTextLink?.toLowerCase().replace(/\s+/g, '-'),
            "aria-label": menuLink?.menuTextLink?.toLowerCase(),
            [ATTRIBUTES.ariaHasPopup]: "true", 
            [ATTRIBUTES.ariaControls]: submenuId,
            role: "menuitem", 

          },
          classes: [CLASSES.expandBtn, CLASSES.layer + '-' + layer],
          children: [
            createElement({ tag: 'div', classes: [CLASSES.expandBtnText], textContent: menuLink.menuTextLink }),
            createElement({
              tag: 'span', classes: [CLASSES.chevron],
              innerHTML: `<svg aria-hidden="true" focusable="false" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z"/>
            </svg>`
            })
          ]
        });

        $expandBtn.addEventListener  ('click', layer === 1 ? handleClickExpandMenuBtn($submenu, $expandBtn) : handleClickExpandSubmenuBtn($submenu, $expandBtn))

        $expandBtn.addEventListener ('keyup', function (event) {
          const handleKeyup = layer === 1 ? handleClickExpandMenuBtn($submenu,$expandBtn) : handleClickExpandSubmenuBtn($submenu, $expandBtn);
          if(event.keyCode === 27 && $expandBtn.getAttribute(ATTRIBUTES.ariaExpanded) === "true") {
            handleKeyup(event);
          }
        })

        if (layer >= 2) {
          const $menuControlPanel = createMenuControlPanel({
            menuTextLink: menuLink.menuTextLink,
            $submenu,
            $expandBtn
          });
          $submenu.insertBefore($menuControlPanel, $submenu.firstChild);
        }

        $li.appendChild($expandBtn);
        $li.appendChild($submenu);
      } else {
        const $link = createElement({
          tag: 'a',
          classes: [CLASSES.link, CLASSES.layer + '-' + layer],
          attributes: {
            href: normalizeLink({
              princesscomAppLinks: menuLink.princesscomAppLinks,
              isExternal: menuLink.isExternal,
              externalUrl: menuLink.externalUrl,
              externalPath: menuLink.externalPath,
              internalPath: menuLink.internalPath
            }),
            ...(layer > 1 && { [ATTRIBUTES.dataComponentLevel]: layer === 2 ? "primaryNav" : "secondaryNav" }),
            [ATTRIBUTES.dataTrack]: layer === 1 ? "primaryNav" : layer === 2 ? "secondaryNav" : "tertiaryNav",
            [ATTRIBUTES.dataTrackId]: menuLink?.menuTextLink?.toLowerCase().replace(/\s+/g, '-'),
            role: "menuitem",
            "aria-label": menuLink?.menuTextLink?.toLowerCase()
          },
          children: [
            createElement({
              tag: 'span',
              classes: [CLASSES.linkText],
              textContent: menuLink.menuTextLink,
            })
          ],
        });
        $li.appendChild($link);
      }

      $ul.appendChild($li);
    }

    // if (layer === 2 && PAGE_WIDTH >= BREAKPOINTS.xs) {
    //   if ($promo)  $ul.appendChild(createPromo($promo));
    //   $ul.appendChild(createCloseBtn([CLASSES.closeBtn, CLASSES.desktop]));
    // }

    // if (layer === 3 && PAGE_WIDTH < BREAKPOINTS.xs) {
    //   if ($promo) $ul.appendChild(createPromo($promo));
    // }
    if(layer>1){
      if ($promo) {
        const $promoLi = createElement({ tag: 'li', attributes: { role: "none" } });
        $promoLi.appendChild(createPromo($promo));
        $ul.appendChild($promoLi);
      }}
    const $closeLi = createElement({ tag: 'li', attributes: { role: "none" } });
    const $closeBtnEl = createCloseBtn(
         (layer === 1) ? [CLASSES.closeBtn] : [CLASSES.closeBtn, CLASSES.desktop]
      );
    $closeLi.appendChild($closeBtnEl);
    $ul.appendChild($closeLi);
    return $ul;
  }

  class MobileNavMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      window.addEventListener('load', async () => {
        try {
          const globalHeader = await fetchGlobalHeader();
          this.render(globalHeader || FALLBACK_GLOBAL_HEADER);
        } catch (error) {
          console.error(error)
          this.render(FALLBACK_GLOBAL_HEADER);
        }
      })
    }

    render(globalHeader) {
      const menuLinks = getMainMenuLinks(globalHeader);
      const findACruiseCta = getFindACruiseCta(globalHeader);
      const $captainCircleHeaderContainer = document.querySelector(CAPTAIN_CIRCLE_HEADER_CONTAINER);
      markAsStandalone($captainCircleHeaderContainer);
      fixElementOnScroll($captainCircleHeaderContainer);
      fixElementOnScroll(document.querySelector(PCL_CAPTAIN_CIRCLE_HEADER));

      const $menu = createMenu({
        menuLinks: menuLinks,
        ulClasses: [CLASSES.menu, CLASSES.layer + '-' + 1],
        liClasses: [CLASSES.menuItem, CLASSES.layer + '-' + 1],
        layer: 1
      });

      const $logo = createLogo();
      const $burgerBtn = createBurgerBtn($menu);
      const $closeBtn = createCloseBtn([CLASSES.closeBtn]);

      const $header = createElement({
        tag: 'div',
        classes: [CLASSES.header],
        children: [
          $logo,
          $burgerBtn,
          $closeBtn,
        ]
      });

      const $searchBtn = createSearchBtn({
        textLink: findACruiseCta.menuTextLink,
      });

      const $pclCaptainCircleHeader = document.createElement(PCL_CAPTAIN_CIRCLE_HEADER);

      const $nav = createElement({
        tag: 'nav',
        classes: [CLASSES.nav],
        children: [
          $header,
          $pclCaptainCircleHeader,
          $menu,
          $searchBtn,
        ]
      });

      const $navMenu = document.querySelector(MOBILE_NAV_MENU);
      $navMenu.appendChild($nav);
    }

  }

    class NavMenu extends HTMLElement {
    constructor() {
      super();
      console.log('Calling ALLBACK_GLOBAL_HEADER')
      this.render(FALLBACK_GLOBAL_HEADER);
    }
    connectedCallback() {
      window.addEventListener('load', async () => {
        try {
          const globalHeader = await fetchGlobalHeader();
          this.render(globalHeader || FALLBACK_GLOBAL_HEADER);
        } catch (error) {
          console.error(error);
          this.render(FALLBACK_GLOBAL_HEADER);
        }
      })
    }

    render(globalHeader) {
      const menuLinks = getMainMenuLinks(globalHeader);
      const findACruiseCta = getFindACruiseCta(globalHeader);
      const $captainCircleHeaderContainer = document.querySelector(CAPTAIN_CIRCLE_HEADER_CONTAINER);
      markAsStandalone($captainCircleHeaderContainer);
      fixElementOnScroll($captainCircleHeaderContainer);
      fixElementOnScroll(document.querySelector(PCL_CAPTAIN_CIRCLE_HEADER));

      const $menu = createMenu({
        menuLinks: menuLinks,
        ulClasses: [CLASSES.menu, CLASSES.layer + '-' + 1],
        liClasses: [CLASSES.menuItem, CLASSES.layer + '-' + 1],
        layer: 1
      });

      const $logo = createLogo();
      const $searchBtn = createSearchBtn({
        textLink: findACruiseCta.menuTextLink,
      });
      
      const $firstLevelColumn = createElement({tag: 'div',
        classes: [CLASSES.firstLevelColumn],
        children: [
          $logo,
          createElement({
            tag: 'div',
            classes: [CLASSES.menuWrapper],
            children: [$menu],
          })
        ]
        });

      const $header = createElement({
        tag: 'div',
        classes: [CLASSES.header],
        children: [
              $firstLevelColumn,
              $searchBtn,
        ]
      });

      const $nav = createElement({
        tag: 'nav',
        classes: [CLASSES.nav],
        children: [
          $header
        ]
      });

      const $navMenu = document.querySelector(NAV_MENU);
      $navMenu.replaceChildren($nav);
    }
  }

  class PclCaptainCircleNav extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const $navMenu = document.createElement(NAV_MENU);
      const $mobileNavMenu = document.createElement(MOBILE_NAV_MENU);
      const $pclCaptainCircleNav = document.querySelector(PCL_CAPTAIN_CIRCLE_NAV);

      $pclCaptainCircleNav.setAttribute('tabindex', '-1');
      $pclCaptainCircleNav.appendChild($navMenu);
      $pclCaptainCircleNav.appendChild($mobileNavMenu);
      if (!window.customElements.get(NAV_MENU)) {
        customElements.define(NAV_MENU, NavMenu);
      }

      if (!window.customElements.get(MOBILE_NAV_MENU)) {
        customElements.define(MOBILE_NAV_MENU, MobileNavMenu);
      }

      if (!document.querySelector(`link[href="${$bookURL}/assetroot/css/global/web-components/pcl-captain-circle-nav/pcl-captain-circle-nav.css"]`)) {
        const linkElem = document.createElement('link');
        linkElem.rel = 'stylesheet';
        linkElem.href = `${$bookURL}/assetroot/css/global/web-components/pcl-captain-circle-nav/pcl-captain-circle-nav.css`;
        document.head.appendChild(linkElem);
      }
    }
  }

  if (!window.customElements.get(PCL_CAPTAIN_CIRCLE_NAV)) {
    customElements.define(PCL_CAPTAIN_CIRCLE_NAV, PclCaptainCircleNav);
  }

}());
})
